import Vue from 'vue'
import Component from 'vue-class-component'

import {
  deltaE,
  hex2rgb,
  hexToHSL,
  HSLAtext,
  adjustLightness,
  RGB
} from '@/styles/theme_generator'

import type { ThemeStruct } from '@/styles/theme_generator'

import { mapState } from 'vuex'


@Component({
  computed: {
    ...mapState('config', ['theme'])
  }
})
export class PrimaryButtonColorDiffMixin extends Vue {

  theme!: ThemeStruct

  get adjustedPrimaryColor(): string | null {
    const primary = this.theme.colors.primary
    const button = this.theme.colors.button || this.theme.colors.primary

    const primary_rgb = hex2rgb(primary)
    const button_rgb = hex2rgb(button)

    if(primary_rgb === null || button_rgb === null) {
      console.error('[PrimaryButtonColorDiffMixin]: An error occurred where no valid theme data was provided')
      return null
    }

    const diffBetweenPrimaryAndButton = deltaE(primary_rgb, button_rgb)

    /*
      https://zschuessler.github.io/DeltaE/learn/
      Delta E	Perception
      <= 1.0  	Not perceptible by human eyes.
      1 - 2	    Perceptible through close observation.
      2 - 10	  Perceptible at a glance.
      11 - 49	  Colors are more similar than opposite
      100	      Colors are exact opposite
    */
    if(diffBetweenPrimaryAndButton < 15) {
      const black: RGB = [0,0,0]
      const white: RGB = [255,255,255]

      const distanceToBlack = deltaE(primary_rgb, black)
      const distanceToWhite = deltaE(primary_rgb, white)
      const primary_hsl = hexToHSL(primary)

      let new_color_val;
      if(distanceToBlack < distanceToWhite) {
        // the primary color is pretty dark, so lighten it
        new_color_val = HSLAtext(adjustLightness(primary_hsl, 0.15));
      }
      else {
        // the primary color is pretty light, so darken it
        new_color_val = HSLAtext(adjustLightness(primary_hsl, -0.15));
      }
      return new_color_val
    }
    else return primary
  }
}
